import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Grid, Button, MenuItem } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { BulkCommisssionUpdate as BULK_UPDATE } from 'Components/Api/CommissionHoldAPI';
import Box from '@material-ui/core/Box';

import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const BulkAction = ({ requestArr, onDismissCallback }) => {
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [RequestObject, setRequestObject] = useState({
        Status: '0',
        AdminRemark: ''
    });

    const validationSchema = Yup.object({
        AdminRemark: Yup.string().required(PLEASE_PROVIDE_VALID + 'remark'),
        Status: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'Status')
            .required(PLEASE_SELECT_VALID + 'Status')
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setLoadingOpen(true);
        let request = [];
        requestArr.forEach((element) => {
            request.push({
                AdminRemark: values.AdminRemark,
                WalletID: element.WalletID,
                RedeemcommissionID: element.RedeemcommissionID,
                Status: values.Status
            });
        });

        var RequestJson = JSON.stringify(request);
        setIsError(false);
        const Response = await BULK_UPDATE(RequestJson);

        setLoadingOpen(false);
        if (!Response.isAuthorized) LOGOUT();

        if (!Response.status) {
            setSeverity('error');
            setResponseMessage(Response.data);
            setIsError(true);
            return;
        }

        setSeverity('success');
        setResponseMessage(Response.data);
        setIsError(true);

        setTimeout(() => {
            onDismissCallback(false);
        }, MESSAGE_CLOSE_AFTER);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={RequestObject}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={RequestObject}
            >
                {(formProps) => {
                    return (
                        <Form>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={10} lg={10}>
                                    <MaterialTextField
                                        label="Admin Remark"
                                        name="AdminRemark"
                                        type="text"
                                        title="Admin Remark"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={2} lg={2}>
                                    <MaterialSelect
                                        label="Status"
                                        name="Status"
                                        title="Status"
                                    >
                                        <MenuItem key="0" value="0">
                                            Select Status
                                        </MenuItem>

                                        <MenuItem key="SUCCESS" value="SUCCESS">
                                            ACCEPT
                                        </MenuItem>
                                        <MenuItem key="FAILURE" value="FAILURE">
                                            REJECT
                                        </MenuItem>
                                    </MaterialSelect>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div
                                    style={{
                                        color: 'green',
                                        marginBottom: '15px'
                                    }}
                                >
                                    Note : Request Status "ACCEPT" means
                                    Commission hold amount transfer to retailer
                                    <br /> Request status "REJECT" means no
                                    transfer.
                                </div>
                            </Grid>
                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Submit"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loadingOpen}
                                        >
                                            Submit
                                        </Button>
                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
